(function () {
  document.querySelectorAll('[data-free-product-page]').forEach(function (page) {
    if (page.dataset.galleryReady === 'true') return;
    page.dataset.galleryReady = 'true';
    var tabs = Array.prototype.slice.call(page.querySelectorAll('[data-free-gallery-tab]'));
    var panels = Array.prototype.slice.call(page.querySelectorAll('[data-free-gallery-panel]'));
    var galleryIndex = 0;
    function showGallery(index) {
      galleryIndex = (index + tabs.length) % tabs.length;
      var target = tabs[galleryIndex].dataset.freeGalleryTab;
      tabs.forEach(function (item, itemIndex) { var active = itemIndex === galleryIndex; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', active ? 'true' : 'false'); });
      panels.forEach(function (panel) { var active = panel.dataset.freeGalleryPanel === target; panel.classList.toggle('is-active', active); panel.setAttribute('aria-hidden', active ? 'false' : 'true'); });
    }
    tabs.forEach(function (tab, index) { tab.addEventListener('click', function () { showGallery(index); }); });
    var previous = page.querySelector('[data-free-gallery-prev]');
    var next = page.querySelector('[data-free-gallery-next]');
    if (previous) previous.addEventListener('click', function () { showGallery(galleryIndex - 1); });
    if (next) next.addEventListener('click', function () { showGallery(galleryIndex + 1); });
    var stage = page.querySelector('[data-free-gallery-stage]');
    if (stage) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchStartedOnBox = false;
      stage.addEventListener('touchstart', function (event) {
        if (!event.touches || !event.touches.length) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        touchStartedOnBox = !!event.target.closest('[data-free-box-stage]');
      }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        if (!event.changedTouches || !event.changedTouches.length) return;
        if (touchStartedOnBox) return;
        var deltaX = event.changedTouches[0].clientX - touchStartX;
        var deltaY = event.changedTouches[0].clientY - touchStartY;
        if (Math.abs(deltaX) < 44 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;
        showGallery(deltaX < 0 ? galleryIndex + 1 : galleryIndex - 1);
      }, { passive: true });
      stage.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') showGallery(galleryIndex - 1);
        if (event.key === 'ArrowRight') showGallery(galleryIndex + 1);
      });
    }

    var boxStage = page.querySelector('[data-free-box-stage]');
    var box = page.querySelector('[data-free-box]');
    if (boxStage && box) {
      var rotateX = -8;
      var rotateY = -24;
      var dragX = 0;
      var dragY = 0;
      var dragging = false;
      function renderBox() { box.style.transform = 'rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)'; }
      boxStage.addEventListener('pointerdown', function (event) {
        dragging = true;
        dragX = event.clientX;
        dragY = event.clientY;
        boxStage.classList.add('is-dragging');
        if (boxStage.setPointerCapture) boxStage.setPointerCapture(event.pointerId);
      });
      boxStage.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        rotateY += (event.clientX - dragX) * .45;
        rotateX = Math.max(-32, Math.min(24, rotateX - (event.clientY - dragY) * .28));
        dragX = event.clientX;
        dragY = event.clientY;
        renderBox();
      });
      function stopBoxDrag() { dragging = false; boxStage.classList.remove('is-dragging'); }
      boxStage.addEventListener('pointerup', stopBoxDrag);
      boxStage.addEventListener('pointercancel', stopBoxDrag);
      boxStage.addEventListener('dblclick', function () { rotateX = -8; rotateY = -24; renderBox(); });
    }

    page.querySelectorAll('[data-free-try]').forEach(function (button) {
      button.addEventListener('click', function () {
        var action = button.dataset.freeTry;
        if (action === 'countdown') {
          var layouts = Array.prototype.slice.call(page.querySelectorAll('[data-free-layout]'));
          var activeLayout = layouts.findIndex(function (item) { return item.classList.contains('is-active'); });
          if (layouts.length) layouts[(activeLayout + 1) % layouts.length].click();
        }
        if (action === 'running') {
          var speedButton = page.querySelector('[data-free-speed]');
          if (speedButton) speedButton.click();
        }
        if (action === 'faq') {
          var faqItems = Array.prototype.slice.call(page.querySelectorAll('.ss-free-faq__list button'));
          var openItem = faqItems.findIndex(function (item) { return item.classList.contains('is-open'); });
          if (faqItems.length) faqItems[(openItem + 1) % faqItems.length].click();
        }
        button.classList.remove('is-used');
        void button.offsetWidth;
        button.classList.add('is-used');
      });
    });
  });

  document.querySelectorAll('[data-free-product-demo]').forEach(function (root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var launch = Date.now() + (6.5 * 86400000);
    function tick() {
      var seconds = Math.max(0, Math.floor((launch - Date.now()) / 1000));
      var values = { days: Math.floor(seconds / 86400), hours: Math.floor((seconds % 86400) / 3600), minutes: Math.floor((seconds % 3600) / 60), seconds: seconds % 60 };
      Object.keys(values).forEach(function (key) {
        var item = root.querySelector('[data-free-' + key + ']');
        if (!item) return;
        var next = String(values[key]).padStart(2, '0');
        if (item.textContent === next) return;
        item.textContent = next;
        item.classList.remove('is-tick');
        void item.offsetWidth;
        item.classList.add('is-tick');
      });
    }
    tick();
    window.setInterval(tick, 1000);

    root.querySelectorAll('[data-free-layout]').forEach(function (button) {
      button.addEventListener('click', function () {
        root.querySelectorAll('[data-free-layout]').forEach(function (item) { item.classList.toggle('is-active', item === button); });
        var preview = root.querySelector('[data-free-layout-preview]');
        if (preview) preview.dataset.freeLayoutPreview = button.dataset.freeLayout;
      });
    });

    var track = root.querySelector('.ss-free-marquee__track');
    var speed = root.querySelector('[data-free-speed]');
    if (speed && track) speed.addEventListener('click', function () {
      var fast = speed.classList.toggle('is-active');
      speed.textContent = fast ? 'SPEED 02' : 'SPEED 01';
      track.style.animationDuration = fast ? '6s' : '13s';
    });
    var running = root.querySelector('.ss-free-run');
    var tone = root.querySelector('[data-free-tone]');
    if (tone && running) tone.addEventListener('click', function () { tone.classList.toggle('is-active'); running.classList.toggle('is-light'); });

    var faqButtons = Array.prototype.slice.call(root.querySelectorAll('.ss-free-faq__list button'));
    var faqIndex = 0;
    var auto = true;
    function openFaq(index) { faqIndex = index; faqButtons.forEach(function (item, i) { item.classList.toggle('is-open', i === index); item.setAttribute('aria-expanded', i === index ? 'true' : 'false'); }); }
    faqButtons.forEach(function (button, index) { button.addEventListener('click', function () { auto = false; var autoButton = root.querySelector('[data-free-auto]'); if (autoButton) { autoButton.textContent = 'AUTO OFF'; autoButton.classList.remove('is-active'); } openFaq(index); }); });
    var autoButton = root.querySelector('[data-free-auto]');
    if (autoButton) autoButton.addEventListener('click', function () { auto = !auto; autoButton.textContent = auto ? 'AUTO ON' : 'AUTO OFF'; autoButton.classList.toggle('is-active', auto); });
    window.setInterval(function () { if (auto && faqButtons.length) openFaq((faqIndex + 1) % faqButtons.length); }, 2600);
  });
})();
